import { Component } from '@angular/core';
import { ApiTermsDocument, TermsApi } from '@tytapp/api';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';


type DocumentKind = 'tos' | 'privacy_policy' | 'core_values';

const RouteToDocument: Record<string, DocumentKind> = {
    terms: 'tos',
    privacy: 'privacy_policy',
    values: 'core_values'
};

@Component({
    selector: 'tyt-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    standalone: false
})
export class TermsComponent {
    constructor(
        private route: ActivatedRoute,
        private termsApi: TermsApi
    ) {}

    routeSubscription: Subscription;

    documentType: DocumentKind;

    document: ApiTermsDocument;

    ngOnInit() {
        this.routeSubscription = this.route.parent.url.subscribe(async url => {
            const [segment] = url;
            this.documentType = RouteToDocument[segment.path];

            if (this.documentType) {
                this.document = null;
                this.document = await this.termsApi.get(this.documentType).toPromise();
            }
        });

    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }
}
